// Round to whole cents - every displayed amount goes through this, so derived
// values (discount, Netto, VAT) computed from rounded parts always add up
export const roundCents = amount => Math.round(Number((amount * 100).toPrecision(12))) / 100

export const formatPrice = (amount, currency) => {
  const fixed = roundCents(amount).toFixed(2)
  if (currency === '£') return `£${fixed}`
  if (currency === 'zł') {
    // Polish format: "1 186,87 zł" with non-breaking spaces
    const [int, dec] = fixed.split('.')
    return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0')},${dec}\u00a0zł`
  }
  return `${fixed} ${currency}`
}

export const productTitle = (product, language) =>
  (language === 'pl' && product?.titlePl) || product?.title
